"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5571],{

/***/ 83680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ CHANGE_LOG_PAGE_SIZE; },
/* harmony export */   "z": function() { return /* binding */ CHANGE_LOGS; }
/* harmony export */ });
var CHANGE_LOGS = {
  'update_1.39.0': {
    title: '1.39.0 버전 업데이트 및 변경사항',
    headline: '더 짧아진 공유 링크, 커스텀 링크까지',
    thumbnail: '/images/updateLog/one_thirty_nine_zero.png',
    date: '2026. 09. 21. 월'
  },
  'update_1.38.0': {
    title: '1.38.0 버전 업데이트 및 변경사항',
    headline: '이메일 캠페인 베타 출시',
    thumbnail: '/images/updateLog/one_thirty_eight_zero.png',
    date: '2026. 08. 25. 화'
  },
  'update_1.37.0': {
    title: '1.37.0 버전 업데이트 및 변경사항',
    headline: 'PDF 뷰어 동영상 임베드 기능 지원',
    thumbnail: '/images/updateLog/one_thirty_seven_zero.png',
    date: '2026. 08. 07. 목'
  },
  'update_1.36.0': {
    title: '1.36.0 버전 업데이트 및 변경사항',
    headline: '고객 페이지에 새로운 리드 알림 추가',
    thumbnail: '/images/updateLog/one_thirty_six_zero.png',
    date: '2026. 07. 21. 화'
  },
  'update_1.35.0': {
    title: '1.35.0 버전 업데이트 및 변경사항',
    headline: '더 빠르고 편리해진 PDF 뷰어',
    thumbnail: '/images/updateLog/one_thirty_five_zero.png',
    date: '2026. 07. 13. 월'
  },
  'update_1.34.0': {
    title: '1.34.0 버전 업데이트 및 변경사항',
    headline: 'PDF·링크 QR 코드 보기',
    thumbnail: '/images/updateLog/one_thirty_four_zero.png',
    date: '2026. 06. 23. 화'
  },
  'update_1.33.0': {
    title: '1.33.0 버전 업데이트 및 변경사항',
    headline: 'PDF 웹 뷰어 콘텐츠 보호',
    thumbnail: '/images/updateLog/one_thirty_three_zero.png',
    date: '2026. 06. 19. 금'
  },
  'update_1.32.0': {
    title: '1.32.0 버전 업데이트 및 변경사항',
    headline: '링크 미리보기 브랜드 커스터마이징',
    thumbnail: '/images/updateLog/one_thirty_two_zero.png',
    date: '2026. 05. 27. 수'
  },
  'update_1.31.0': {
    title: '1.31.0 버전 업데이트 및 변경사항',
    headline: '링크 대량발송용 지원',
    thumbnail: '/images/updateLog/one_thirty_one_zero.png',
    date: '2026. 05. 14. 목'
  },
  'update_1.30.0': {
    title: '1.30.0 버전 업데이트 및 변경사항',
    headline: 'PDF 대량발송용 파일 고객 연동 지원',
    thumbnail: '/images/updateLog/one_thirty_zero.png',
    date: '2026. 05. 09. 토'
  },
  'update_1.29.0': {
    title: '1.29.0 버전 업데이트 및 변경사항',
    headline: 'PDF 뷰어 열람 UTM 수집 및 조회 기능 추가',
    thumbnail: '/images/updateLog/one_twenty_nine_zero.png',
    date: '2026. 05. 03. 일'
  },
  'update_1.28.0': {
    title: '1.28.0 버전 업데이트 및 변경사항',
    headline: '문의양식 전체 동의 기능 추가',
    thumbnail: '/images/updateLog/one_twenty_eight_zero.png',
    date: '2026. 04. 28. 화'
  },
  'update_1.27.0': {
    title: '1.27.0 버전 업데이트 및 변경사항',
    headline: '봇 탐지 및 필터링 기능 지원',
    thumbnail: '/images/updateLog/one_twenty_seven_zero.png',
    date: '2026. 04. 12. 일'
  },
  'update_1.26.0': {
    title: '1.26.0 버전 업데이트 및 변경사항',
    headline: '대용량 PDF 업로드 지원',
    thumbnail: '/images/updateLog/one_twenty_six_zero.png',
    date: '2026. 03. 10. 화'
  },
  'update_1.25.0': {
    title: '1.25.0 버전 업데이트 및 변경사항',
    headline: '실시간 슬랙 알림 지원',
    thumbnail: '/images/updateLog/one_twenty_five_zero.png',
    date: '2026. 01. 29. 목'
  },
  'update_1.24.0': {
    title: '1.24.0 버전 업데이트 및 변경사항',
    headline: '전체 열람 통계에 유입 경로 통계 추가',
    thumbnail: '/images/updateLog/one_twenty_four_zero.png',
    date: '2026. 01. 14. 수'
  },
  'update_1.23.0': {
    title: '1.23.0 버전 업데이트 및 변경사항',
    headline: '유입 경로까지 확인되는 리드 열람 분석',
    thumbnail: '/images/updateLog/one_twenty_three_zero.png',
    date: '2026. 01. 08. 목'
  },
  'update_1.22.0': {
    title: '1.22.0 버전 업데이트 및 변경사항',
    headline: 'PDF 업로드 기능 개선',
    thumbnail: '/images/updateLog/one_twenty_two_zero.png',
    date: '2025. 11. 19. 수'
  },
  'update_1.21.0': {
    title: '1.21.0 버전 업데이트 및 변경사항',
    headline: '뷰어 링크 안정성 및 UX 개선',
    thumbnail: '/images/updateLog/one_twenty_one.png',
    date: '2025. 10. 28. 화'
  },
  'update_1.20.0': {
    title: '1.20.0 버전 업데이트 및 변경사항',
    headline: 'PDF 웹 뷰어에서 내부 페이지 이동 하이퍼링크 지원',
    thumbnail: '/images/updateLog/one_twenty_zero.png',
    date: '2025. 10. 22. 수'
  },
  'update_1.19.0': {
    title: '1.19.0 버전 업데이트 및 변경사항',
    headline: '문의양식 이메일 인증 기능 추가',
    thumbnail: '/images/updateLog/one_nineteen_zero.png',
    date: '2025. 09. 09. 화'
  },
  'update_1.18.0': {
    title: '1.18.0 버전 업데이트 및 변경사항',
    headline: '세일즈클루 뷰어 UI 다국어 지원 확대',
    thumbnail: '/images/updateLog/one_eighteen_zero.png',
    date: '2025. 08. 13. 수'
  },
  'update_1.17.0': {
    title: '1.17.0 버전 업데이트 및 변경사항',
    headline: '전체 열람 통계에 국가 통계 추가',
    thumbnail: '/images/updateLog/one_seventeen_zero.png',
    date: '2025. 08. 08. 금'
  },
  'update_1.16.0': {
    title: '1.16.0 버전 업데이트 및 변경사항',
    headline: '열람인의 국가·도시 정보 확인',
    thumbnail: '/images/updateLog/one_sixteen_zero.png',
    date: '2025. 08. 01. 금'
  },
  'update_1.15.0': {
    title: '1.15.0 버전 업데이트 및 변경사항',
    headline: '열람/문의양식(폼) 제출 알림 설정 분리',
    thumbnail: '/images/updateLog/one_fifteen_zero.png',
    date: '2025. 07. 16. 수'
  },
  'update_1.14.0': {
    title: '1.14.0 버전 업데이트 및 변경사항',
    headline: '실시간 열람 알림 설정 기능 추가',
    thumbnail: '/images/updateLog/one_fourteen_zero.png',
    date: '2025. 07. 04. 금'
  },
  'update_1.13.0': {
    title: '1.13.0 버전 업데이트 및 변경사항',
    headline: '모바일 뷰어에서 메시지 박스 기능 지원',
    thumbnail: '/images/updateLog/one_thirteen_zero.png',
    date: '2025. 06. 10. 화'
  },
  'update_1.12.0': {
    title: '1.12.0 버전 업데이트 및 변경사항',
    headline: '플랜 배지로 현재 사용 중인 플랜을 한눈에',
    thumbnail: '/images/updateLog/one_twelve_zero.png',
    date: '2025. 06. 02. 월'
  },
  'update_1.11.0': {
    title: '1.11.0 버전 업데이트 및 변경사항',
    headline: '다국어 뷰어 지원',
    thumbnail: '/images/updateLog/one_eleven_zero.png',
    date: '2025. 05. 22. 목'
  },
  'update_1.10.0': {
    title: '1.10.0 버전 업데이트 및 변경사항',
    headline: 'PDF 색상 및 그라데이션 표현 개선',
    thumbnail: '/images/updateLog/one_ten_zero.png',
    date: '2025. 04. 29. 화'
  },
  'update_1.9.1': {
    title: '1.9.1 버전 업데이트 및 변경사항',
    headline: '보안 설정된 PDF도 업로드할 수 있어요!',
    thumbnail: '/images/updateLog/one_nine_one.png',
    date: '2025. 04. 18. 금'
  },
  'update_1.9.0': {
    title: '1.9.0 버전 업데이트 및 변경사항',
    headline: '1:1 발송용과 대량 발송용 파일이 통합되었습니다',
    thumbnail: '/images/updateLog/one_nine_zero.png',
    date: '2024. 04. 12. 금'
  },
  'update_1.8.0': {
    title: '1.8.0 버전 업데이트 및 변경사항',
    headline: '대량발송용 파일을 구글애널리틱스, 구글태그매니저에 연동',
    thumbnail: '/images/updateLog/one_eight_zero.png',
    date: '2024. 04. 11. 목'
  },
  'update_1.7.0': {
    title: '1.7.0 버전 업데이트 및 변경사항',
    headline: '뷰어가 새롭게 재단장 되었습니다.',
    thumbnail: '/images/updateLog/one_seven_zero.png',
    date: '2024. 03. 28. 목'
  },
  'update_1.6.0': {
    title: '1.6.0 버전 업데이트 및 변경사항',
    headline: '자료 일부를 ‘가림막’으로 가려 관심있는 고객 골라내기',
    thumbnail: '/images/updateLog/one_six_zero.png',
    date: '2024. 02. 29. 수'
  },
  'update_1.5.0': {
    title: '1.5.0 버전 업데이트 및 변경사항',
    headline: 'PDF 콘텐츠로 잠재 고객 이메일을 수집할 수 있어요.',
    thumbnail: '/images/updateLog/one_five_zero.png',
    date: '2023. 10. 26. 목'
  },
  'update_1.4.0': {
    title: '1.4.0 버전 업데이트 및 변경사항',
    headline: 'PDF 자료에 메시지 박스를 더해보세요!',
    thumbnail: '/images/updateLog/one_four_zero.png',
    date: '2023. 10. 10. 화'
  },
  'update_1.3.0': {
    title: '1.3.0 버전 업데이트 및 변경사항',
    headline: 'PDF 원본에 포함된 링크도 클릭 추적이 됩니다.',
    thumbnail: '/images/updateLog/one_three_zero.png',
    date: '2023. 08. 22. 화'
  },
  'update_1.2.0': {
    title: '1.2.0 버전 업데이트 및 변경사항',
    headline: '세일즈클루 링크는 그대로 두고, 파일만 교체',
    thumbnail: '/images/updateLog/one_two_zero.png',
    date: '2023. 07. 25. 화'
  },
  'update_1.1.0': {
    title: '1.1.0 버전 업데이트 및 변경사항',
    headline: '열람 기록에서 특정 IP를 제외할 수 있어요.',
    thumbnail: '/images/updateLog/one_one_zero.png',
    date: '2023. 07. 12. 월'
  }
};
var CHANGE_LOG_PAGE_SIZE = 6;

/***/ }),

/***/ 55571:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ User; }
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./hooks/useUpdateAccessToken.ts
var useUpdateAccessToken = __webpack_require__(98861);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../packages/pds-react/src/index.ts + 66 modules
var src = __webpack_require__(61810);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(39097);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/ChangeLog/constant.ts
var constant = __webpack_require__(83680);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(7328);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 1 modules
var emotion_styled_base_browser_esm = __webpack_require__(36557);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
// EXTERNAL MODULE: ./constants/zIndex.ts
var zIndex = __webpack_require__(90122);
;// CONCATENATED MODULE: ./components/Layouts/User/UpdateBanner/BannerCard/index.styles.ts



var _templateObject, _templateObject2;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var slideUp = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var slideOut = (0,emotion_react_browser_esm/* keyframes */.F4)(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n  from {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n  to {\n    opacity: 0;\n    transform: translateY(12px) scale(0.96);\n  }\n"])));
var Card = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("aside",  true ? {
  target: "ecww70b3"
} : 0)("position:relative;overflow:hidden;width:320px;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.white;
}, ";border:1px solid ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.zinc_200;
}, ";border-radius:12px;box-shadow:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.elevation.md;
}, ";", function (_ref4) {
  var isAnimated = _ref4.isAnimated,
      isClosing = _ref4.isClosing;

  if (isClosing) {
    return /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("animation:", slideOut, " 0.15s ease-in-out forwards;" + ( true ? "" : 0),  true ? "" : 0);
  }

  return isAnimated && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("animation:", slideUp, " 0.15s ease-in-out;" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var ThumbnailWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecww70b2"
} : 0)("position:relative;width:100%;padding-top:36.6%;background-color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.zinc_100;
}, ";border-bottom:1px solid ", function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.zinc_200;
}, ";" + ( true ? "" : 0));
var CloseButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "ecww70b1"
} : 0)("position:absolute;top:8px;right:8px;z-index:", zIndex/* Z_INDEX.onTop */.k.onTop, ";display:flex;width:24px;height:24px;align-items:center;justify-content:center;color:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.white;
}, ";background-color:", function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.zinc_700;
}, ";border-radius:50%;opacity:0.8;transition:opacity 0.15s ease-in-out;&:hover{opacity:1;}" + ( true ? "" : 0));
var Description = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Text */.xv,  true ? {
  target: "ecww70b0"
} : 0)( true ? {
  name: "nwa1ae",
  styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;-webkit-line-clamp:3;word-break:keep-all"
} : 0);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./components/Layouts/User/UpdateBanner/BannerCard/index.tsx









var BannerCard = function BannerCard(_ref) {
  var tab = _ref.tab,
      description = _ref.description,
      isAnimated = _ref.isAnimated,
      onClose = _ref.onClose;
  var _CHANGE_LOGS$tab = constant/* CHANGE_LOGS */.z[tab],
      headline = _CHANGE_LOGS$tab.headline,
      thumbnail = _CHANGE_LOGS$tab.thumbnail;

  var _useState = (0,react.useState)(false),
      isClosing = _useState[0],
      setIsClosing = _useState[1]; // 닫기 애니메이션이 끝난 뒤에 실제로 제거한다.


  var handleAnimationEnd = function handleAnimationEnd() {
    if (isClosing) {
      onClose();
    }
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Card, {
    isAnimated: isAnimated,
    isClosing: isClosing,
    onAnimationEnd: handleAnimationEnd,
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CloseButton, {
      type: "button",
      "aria-label": "\uC5C5\uB370\uC774\uD2B8 \uBC30\uB108 \uB2EB\uAE30",
      onClick: function onClick() {
        return setIsClosing(true);
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
        icon: "ph:x",
        size: 14,
        color: "inherit"
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbnailWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
        src: thumbnail,
        layout: "fill",
        objectFit: "cover",
        sizes: "320px",
        alt: headline
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
      gap: 12,
      direction: "column",
      padding: 16,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(src/* Stack */.Kq, {
        gap: 4,
        direction: "column",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          variant: "sm-semibold",
          color: "skyblue_500",
          children: "\uC0C8\uB85C\uC6B4 \uC5C5\uB370\uC774\uD2B8"
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Text */.xv, {
          as: "p",
          variant: "lg-semibold",
          color: "zinc_700",
          children: headline
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description, {
          as: "p",
          variant: "sm-medium",
          color: "zinc_500",
          children: description
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
        href: "/change-log?tab=".concat(tab),
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Button */.zx, {
          variant: "skyblue_400_fill",
          textVariant: "md-medium",
          width: "100%",
          rightIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(src/* Icon */.JO, {
            icon: "ph:caret-right",
            size: 16,
            color: "white"
          }),
          onClick: onClose,
          children: "\uC5C5\uB370\uC774\uD2B8 \uBCF4\uAE30"
        })
      })]
    })]
  });
};

/* harmony default export */ var UpdateBanner_BannerCard = (BannerCard);
;// CONCATENATED MODULE: ./components/Layouts/User/UpdateBanner/index.constants.ts
/**
 * 좌측 하단에 띄울 업데이트 배너 목록. 최신순으로 작성한다.
 * 한 개만 두면 단독 카드로, 여러 개를 두면 카드가 겹쳐 쌓인 형태로 노출되며
 * 배열의 첫 번째(최신) 항목이 가장 앞에 보이고 이전 버전은 뒤로 겹친다.
 * 카드마다 닫기 버튼이 있어 버전별로 각각 숨길 수 있다.
 */
var UPDATE_BANNERS = [{
  tab: 'update_1.39.0',
  description: '공유 링크가 더 짧아졌습니다. 원하는 주소의 커스텀 링크도 설정해 보세요.'
}, {
  tab: 'update_1.38.0',
  description: '이메일 발송부터 오픈·클릭·콘텐츠 열람 반응까지, 세일즈클루에서 한 번에 확인하세요.'
}, {
  tab: 'update_1.37.0',
  description: '이제 PDF 위에 YouTube·Vimeo 동영상을 더해 고객에게 전달해 보세요!'
}];
var CHANGE_LOG_PATH = '/change-log';
/* 기존 저장값을 유지하기 위해 'update_1.37.0' -> 'hideUpdateBanner:v1.37.0' 형태를 그대로 사용한다. */

var getStorageKey = function getStorageKey(tab) {
  return "hideUpdateBanner:v".concat(tab.replace('update_', ''));
};
;// CONCATENATED MODULE: ./components/Layouts/User/UpdateBanner/index.styles.ts


function index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



/* 좌측 하단 채널톡 런처(left/bottom 24px, 56px)와 겹치지 않게 그 위에 띄운다. */

var SIDE_GAP = 24;
var CHANNEL_TALK_SIZE = 56;
var CHANNEL_TALK_GAP = 16;
var CARD_WIDTH = 320;
/* 뒤쪽 카드가 위로 삐져나오는 정도(겹쳐 쌓인 것이 보이도록) */

var DEPTH_OFFSET = 16;
var DEPTH_SCALE = 0.05;
/* 스택 내부 순서용 값(전역 z-index가 아닌 컨테이너 안에서의 순서) */

var STACK_LAYER = 10;
var BannerStack = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1s70w5s1"
} : 0)("position:fixed;bottom:", SIDE_GAP + CHANNEL_TALK_SIZE + CHANNEL_TALK_GAP, "px;left:", SIDE_GAP, "px;z-index:", zIndex/* Z_INDEX.floatingBanner */.k.floatingBanner, ";width:", CARD_WIDTH, "px;" + ( true ? "" : 0));
/* depth 0(최신)이 가장 앞에 오고, 이전 버전은 뒤로 겹쳐 쌓인다. */

var _ref =  true ? {
  name: "bjn8wh",
  styles: "position:relative"
} : 0;

var CardSlot = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1s70w5s0"
} : 0)("z-index:", function (_ref2) {
  var depth = _ref2.depth;
  return STACK_LAYER - depth;
}, ";", function (_ref3) {
  var depth = _ref3.depth;
  return depth === 0 ? _ref : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("position:absolute;right:0;bottom:0;left:0;transform:translateY(", -DEPTH_OFFSET * depth, "px) scale(", 1 - DEPTH_SCALE * depth, ");transform-origin:bottom center;" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/Layouts/User/UpdateBanner/index.tsx




 // 페이지 이동마다 배너가 다시 마운트되므로 노출 여부를 모듈 단위로 기억한다.
// 첫 판단 이후에는 초기 렌더부터 바로 노출되어 깜빡임과 등장 애니메이션 재생이 없다.


var cachedVisibleTabs = null;

var UpdateBanner = function UpdateBanner() {
  var _cachedVisibleTabs;

  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)((_cachedVisibleTabs = cachedVisibleTabs) !== null && _cachedVisibleTabs !== void 0 ? _cachedVisibleTabs : []),
      visibleTabs = _useState[0],
      setVisibleTabs = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isAnimated = _useState2[0],
      setIsAnimated = _useState2[1];

  (0,react.useEffect)(function () {
    if (cachedVisibleTabs !== null) {
      return;
    } // '1'이면 숨김


    cachedVisibleTabs = UPDATE_BANNERS.filter(function (_ref) {
      var tab = _ref.tab;
      return localStorage.getItem(getStorageKey(tab)) !== '1';
    }).map(function (_ref2) {
      var tab = _ref2.tab;
      return tab;
    });
    setVisibleTabs(cachedVisibleTabs);
    setIsAnimated(cachedVisibleTabs.length > 0); // 등장 애니메이션은 최초 노출에서만 재생한다.
  }, []);
  var banners = UPDATE_BANNERS.filter(function (_ref3) {
    var tab = _ref3.tab;
    return visibleTabs.includes(tab);
  }); // 업데이트 내용을 보고 있는 변경사항 페이지에서는 노출하지 않는다.

  if (banners.length === 0 || router.pathname === CHANGE_LOG_PATH) {
    return null;
  }

  var hideForever = function hideForever(tab) {
    var _cachedVisibleTabs2;

    localStorage.setItem(getStorageKey(tab), '1');
    cachedVisibleTabs = ((_cachedVisibleTabs2 = cachedVisibleTabs) !== null && _cachedVisibleTabs2 !== void 0 ? _cachedVisibleTabs2 : []).filter(function (key) {
      return key !== tab;
    });
    setVisibleTabs(cachedVisibleTabs);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BannerStack, {
    children: banners.map(function (_ref4, index) {
      var tab = _ref4.tab,
          description = _ref4.description;
      return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSlot, {
        depth: index,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UpdateBanner_BannerCard, {
          tab: tab,
          description: description,
          isAnimated: isAnimated,
          onClose: function onClose() {
            return hideForever(tab);
          }
        })
      }, tab);
    })
  });
};

/* harmony default export */ var User_UpdateBanner = (UpdateBanner);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/useCheckOverPeriod.ts
var useCheckOverPeriod = __webpack_require__(91378);
// EXTERNAL MODULE: ./components/Layouts/TopBanner/index.tsx + 2 modules
var TopBanner = __webpack_require__(33336);
// EXTERNAL MODULE: ./components/Layouts/User/Header/index.tsx + 5 modules
var Header = __webpack_require__(842);
;// CONCATENATED MODULE: ./components/Layouts/User/index.styles.ts


function User_index_styles_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lqyo4l3"
} : 0)("min-height:100vh;background-color:", function (_ref) {
  var theme = _ref.theme;
  return theme.colors.zinc_50;
}, ";" + ( true ? "" : 0));
var InnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(src/* Flex */.kC,  true ? {
  target: "e1lqyo4l2"
} : 0)( true ? {
  name: "1r6izg0",
  styles: "width:1080px;margin:0 auto"
} : 0);
var NavWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1lqyo4l1"
} : 0)( true ? {
  name: "vn923z",
  styles: "padding-top:70px;margin-bottom:16px"
} : 0);
var Main = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("main",  true ? {
  target: "e1lqyo4l0"
} : 0)("display:grid;", function (_ref2) {
  var hasNav = _ref2.hasNav;
  return hasNav && "padding-top: 70px;";
}, " padding-bottom:48px;column-gap:16px;", function (_ref3) {
  var isReverseGridTemplateColumns = _ref3.isReverseGridTemplateColumns;
  return isReverseGridTemplateColumns ? "\n      grid-template-columns: 715px 349px;\n    " : "\n      grid-template-columns: 349px 715px;\n      ";
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./components/Layouts/User/index.tsx










var UserLayout = function UserLayout(_ref) {
  var _ref$isReverseGridTem = _ref.isReverseGridTemplateColumns,
      isReverseGridTemplateColumns = _ref$isReverseGridTem === void 0 ? false : _ref$isReverseGridTem,
      nav = _ref.nav,
      children = _ref.children;

  var _useCheckOverPeriod = (0,useCheckOverPeriod/* default */.Z)({
    targetDate: TopBanner/* TARGET_DATE */.Tm
  }),
      isValid = _useCheckOverPeriod.isValid;

  (0,useUpdateAccessToken/* default */.Z)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Wrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Header/* default */.Z, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(User_UpdateBanner, {}), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerWrapper, {
      direction: "column",
      padding: {
        top: isValid ? 30 : 0,
        bottom: 180
      },
      children: [nav && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavWrapper, {
        children: nav
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Main, {
        isReverseGridTemplateColumns: isReverseGridTemplateColumns,
        hasNav: nav == undefined,
        className: 'main',
        children: children
      })]
    })]
  });
};

/* harmony default export */ var User = (UserLayout);

/***/ }),

/***/ 61342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getUserToken */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95235);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7040);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74457);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



var getUserToken = function getUserToken() {
  return _utils_api__WEBPACK_IMPORTED_MODULE_1__/* .api.get */ .h.get('/auth/token');
};

var useUserToken = function useUserToken(options) {
  return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)(['getUserToken'], getUserToken, _objectSpread({
    enabled: false,
    retry: false
  }, options));
};

/* harmony default export */ __webpack_exports__["Z"] = (useUserToken);

/***/ }),

/***/ 98861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89644);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jotai__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _state_user_atom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37271);
/* harmony import */ var _queries_auth_useUserToken__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61342);
/* harmony import */ var _queries_user_useUserInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73327);







var useUpdateAccessToken = function useUpdateAccessToken() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useUserToken = (0,_queries_auth_useUserToken__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
    onSuccess: function onSuccess() {
      return refetchUserInfo();
    },
    onError: function onError() {
      return router.push('/login');
    }
  }),
      refetchUserToken = _useUserToken.refetch;

  var setUserInfo = (0,jotai__WEBPACK_IMPORTED_MODULE_5__/* .useSetAtom */ .b9)(_state_user_atom__WEBPACK_IMPORTED_MODULE_2__/* .userInfoAtom */ .w);

  var _useUserInfo = (0,_queries_user_useUserInfo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    onSuccess: function onSuccess(data) {
      setUserInfo(data.data.data.user);
    },
    onError: function onError(error) {
      var _error$response;

      if (axios__WEBPACK_IMPORTED_MODULE_0___default().isAxiosError(error) && (_error$response = error.response) !== null && _error$response !== void 0 && _error$response.data) {
        var status = error.response.status;

        if (status === 403) {
          refetchUserToken();
        }
      }
    },
    enabled: true
  }),
      refetchUserInfo = _useUserInfo.refetch;
};

/* harmony default export */ __webpack_exports__["Z"] = (useUpdateAccessToken);

/***/ })

}]);